import { Controller } from '@hotwired/stimulus'

export default class ModifierController extends Controller {
  static targets = [
    'option',
    'rule'
  ]

  static values = {
    id: String,
    min: Number,
    max: Number,
    calculation: String,
    position: Number,
    isRequired: Boolean,
    isLimitless: Boolean,
    options: { type: Array, default: [] },
    total: { type: Number, default: 0 },
    isValid: Boolean,
    isReachedLimit: Boolean
  }

  addOption ({ detail: { id, price, amount } }) {
    if (!this.isReachedLimit) {
      this.optionsValue = [{ id, price, amount }, ...this.optionsValue]
    }
  }

  removeOption ({ detail: { id } }) {
    const index = this.optionsValue.findIndex(option => option.id === id)
    this.optionsValue = this.optionsValue.filter((option, optionIndex) => optionIndex !== index)
  }

  optionsValueChanged () {
    this.totalValue = this.total
    this.isValidValue = this.isValid
    this.isReachedLimitValue = this.isReachedLimit

    this.dispatch('modifierChanged', { detail: this.modifier, bubbles: true })

    this.dispatch('modifierChanged', { target: this.ruleTarget, detail: this.modifier })

    this.optionTargets.forEach(optionTarget =>
      this.dispatch('modifierChanged', { target: optionTarget, detail: this.modifier })
    )
  }

  get isValid () {
    if (this.minValue === 0) {
      return true
    }

    return this.optionsValue.length >= this.minValue
  }

  get isReachedLimit () {
    if (this.isLimitlessValue) {
      return false
    }

    return this.optionsValue.length >= this.maxValue
  }

  get total () {
    if (this.optionsValue.length <= 0) {
      return 0
    }

    switch (this.calculationValue) {
      case 'ADDITION':
        return this.optionsValue.reduce((acc, option) => acc + option.price, 0)
      case 'APPORTIONMENT':
        return this.optionsValue.reduce((acc, option) => acc + option.price, 0) / this.optionsValue.length
      case 'HIGHEST':
        return Math.max.apply(Math, this.optionsValue.map(option => option.price))
      default:
        return 0
    }
  }

  get modifier () {
    return {
      id: this.idValue,
      min: this.optionsValue.length,
      max: this.maxValue,
      calculation: this.calculationValue,
      position: this.positionValue,
      isRequired: this.isRequiredValue,
      isLimitless: this.isLimitlessValue,
      options: this.optionsValue,
      total: this.totalValue,
      isValid: this.isValid,
      isReachedLimit: this.isReachedLimit
    }
  }
}
